import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { CstemapiService } from '../cstemapi.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  userObj: any = {};
  userInfo: any = {};

  constructor(public cstemapi: CstemapiService, private auth: AuthService) {
    this.userInfo = this.auth.getUserInfo();
    // console.log(this.userInfo)
    if (this.auth.getUserInfo() != '') {
      if (this.auth.getUserInfo().roleCode == 'usr') {
        this.userObj['name'] = this.userInfo.userName;
        this.userObj['emailId'] = this.userInfo.emailId;
        this.userObj['userId'] = this.auth.getUserId();
        this.userObj['ratings'] = 5;
        this.userObj['usrRoleCode'] = this.userInfo.roleCode;
        this.userObj['organization'] = this.userInfo.organizationName;
        this.userObj['designation'] = this.userInfo.userTypeName;
      } else {
        // this.userObj['userId'] = this.auth.getUserId();
        // this.userObj['ratings'] = 5;
        this.userObj['usrRoleCode'] = this.userInfo.roleCode;
      }
    } else {
      this.userObj['usrRoleCode'] = 'gusr';
    }

  }

  ngOnInit() {
  }

  feedbackSubmit() {
    var api = 'profile/provideFeedback';
    this.cstemapi.cstemAPI(this.userObj).Feedback.subscribe(data => {
      this.cstemapi.printReqRes(this.userObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        delete this.userObj.feedback;
        this.cstemapi.Swal.fire('Successfully submitted', '', 'success');
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting Organization Type!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

}
